/* eslint-env browser */
/*
 * Automatically updates nav targets based on scroll position
 *
 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
 */
require('../bootstrap/js/scrollspy');
